module.exports = __webpack_public_path__ + "img/exercise_new.bf9ba54d.png";